import {
    marketShareColumns as cols
} from './marketShareColumns';
import { gridColumnDefinitions as gridCols } from './gridColumns';
import { showHideTypes } from './index';
import { listingViews } from './listingViews';
import { marketShareTerms } from './index';

const defaultShowHideOptions = [
    { ...showHideTypes.onlyShowSelectedAreas, hide: true},
    { ...showHideTypes.chart, isDefault: true, hide: false }
];

const showHideForSaleCols = [
    {...gridCols.avgListDom, hide: false},
    {...gridCols.totalAvgPrice, hide: false, isCoverage: true},
    {...gridCols.mlsAgentCount, hide: false},
    {...gridCols.mlsOfficeCount, hide: false}
];

const settingsTotalVolumeUnits = {
    showHideOptions: {
        options: defaultShowHideOptions,
        columns: [
            { ...cols.marketSharePct, isDefault: true, hide: false },
            { ...cols.totalAvgPrice, isDefault: true, hide: false },
            { ...cols.totalProdAgentSearchCount, isDefault: true, hide: false },
            { ...cols.mlsOfficeCount, isDefault: true, hide: false }
        ]
    },
    columns: [
        gridCols.isSelected,
        gridCols.rank,
        gridCols.area,
        gridCols.listVolume,
        gridCols.listUnits,
        gridCols.sellVolume,
        gridCols.sellUnits,
        gridCols.totalVolume,
        gridCols.totalUnits,
        {...gridCols.marketSharePct, hide: false, isCoverage: true},
        { ...gridCols.totalAvgPrice, hide: false, isCoverage: true },
        {...gridCols.totalProdAgentSearchCount, hide: false},
        {...gridCols.mlsOfficeCount, hide: false}
    ]
};

const settingsForSaleVolume = {
    showHideOptions: {
        options: defaultShowHideOptions,
        columns: [
            { ...cols.unitSharePct, isDefault: true, hide: false },
            { ...cols.marketSharePct, isDefault: true, hide: false, label: marketShareTerms.volumePct },
            { ...cols.avgListDom, isDefault: true, hide: false },
            { ...cols.totalAvgPrice, isDefault: true, hide: false },
            { ...cols.mlsAgentCount, isDefault: true, hide: false },
            { ...cols.mlsOfficeCount, isDefault: true, hide: false }
            ]
        },
    columns: [
        gridCols.isSelected,
        gridCols.rank,
        gridCols.area,
        {...gridCols.actVolume, isCoverage: true},
        {...gridCols.actUnits, isCoverage: true},
        gridCols.unitSharePct,
        {...gridCols.marketSharePct, hide:false, headerName: marketShareTerms.volumePct, tooltip:gridCols.volumeSharePct.field, minWidth: 140},
        ...showHideForSaleCols
    ]
};

const settingsForSaleUnits = {
    showHideOptions: {
        options: defaultShowHideOptions,
        columns: [
            { ...cols.marketSharePct, isDefault: true, hide: false, label: marketShareTerms.unitPct },
            { ...cols.volumeSharePct, isDefault: true, hide: false },
            { ...cols.avgListDom, isDefault: true, hide: false },
            { ...cols.totalAvgPrice, isDefault: true, hide: false },
            { ...cols.mlsAgentCount, isDefault: true, hide: false },
            { ...cols.mlsOfficeCount, isDefault: true, hide: false }
        ]
    },
    columns: [
        gridCols.isSelected,
        gridCols.rank,
        gridCols.area,
        {...gridCols.actVolume, isCoverage: true},
        {...gridCols.actUnits, isCoverage: true},
        {...gridCols.marketSharePct, hide:false, headerName: marketShareTerms.unitPct, tooltip:gridCols.unitSharePct.field, minWidth: 110},
        gridCols.volumeSharePct,
        ...showHideForSaleCols
    ]
};

const settingsListSide = {
    showHideOptions: {
        options: defaultShowHideOptions,
        columns: [
            { ...cols.marketSharePct, isDefault: true, hide: false },
            { ...cols.avgListDom, isDefault: true, hide: false},
            { ...cols.listAvgPrice, isDefault: true, hide: false },
            { ...cols.listSpop, isDefault: true, hide: false },
            { ...cols.clr, isDefault: true, hide: false },
            { ...cols.mlsAgentCount, isDefault: true, hide: false },
            { ...cols.listProdAgentSearchCount, isDefault: true, hide: false },
            { ...cols.mlsOfficeCount, isDefault: true, hide: false }
        ]
    },
    columns: [
        gridCols.isSelected,
        gridCols.rank,
        gridCols.area,
        gridCols.listVolume,
        gridCols.listUnits,
        {...gridCols.marketSharePct, hide: false, isCoverage: true},
        {...gridCols.clr, hide: false, isCoverage: true},
        {...gridCols.avgListDom, hide: false},
        {...gridCols.listAvgPrice, hide: false},
        { ...gridCols.listSpop, hide: false },
        {...gridCols.mlsAgentCount, hide: false},
        {...gridCols.listProdAgentSearchCount, hide: false},
        {...gridCols.mlsOfficeCount, hide: false}
    ]
};

const settingsSellSide = {
    showHideOptions: {
        options: defaultShowHideOptions,
        columns: [
            { ...cols.marketSharePct, isDefault: true, hide: false },
            { ...cols.sellAvgPrice, isDefault: true, hide: false },
            { ...cols.sellSpop, isDefault: true, hide: false },
            { ...cols.mlsAgentCount, isDefault: true, hide: false },
            { ...cols.sellProdAgentSearchCount, isDefault: true, hide: false },
            { ...cols.mlsOfficeCount, isDefault: true, hide: false }
        ]
    },
    columns: [
        gridCols.isSelected,
        gridCols.rank,
        gridCols.area,
        gridCols.sellVolume,
        gridCols.sellUnits,
        {...gridCols.marketSharePct, hide: false, isCoverage: true},
        {...gridCols.sellAvgPrice, hide: false},
        { ...gridCols.sellSpop, hide: false },
        {...gridCols.mlsAgentCount, hide: false},
        {...gridCols.sellProdAgentSearchCount, hide: false},
        {...gridCols.mlsOfficeCount, hide: false}
    ]
};

export const coverageListingViews = Object.freeze({
    total$Volume: {
        ...listingViews.total$Volume,
        settings: settingsTotalVolumeUnits
    },
    totalNumUnits: {
        ...listingViews.totalNumUnits,
        settings: settingsTotalVolumeUnits
    },
    listSide$Volume: {
        ...listingViews.listSide$Volume,
        settings: settingsListSide
    },
    listSideNumUnits: {
        ...listingViews.listSideNumUnits,
        settings: settingsListSide
    },
    sellSide$Volume: {
        ...listingViews.sellSide$Volume,
        settings: settingsSellSide
    },
    sellSideNumUnits: {
        ...listingViews.sellSideNumUnits,
        settings: settingsSellSide
    },
    forSale$Volume: {
        ...listingViews.forSale$Volume,
        label: marketShareTerms.coverageForSale$Volume,
        settings: settingsForSaleVolume
    },
    forSaleNumUnits: {
        ...listingViews.forSaleNumUnits,
        label: marketShareTerms.coverageForSaleNumUnits,
        settings: settingsForSaleUnits
    }
});
